// extracted by mini-css-extract-plugin
export default {"order__main":"OrderMain_order__main__fTSuO"};